"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ImageFill_exports = {};
__export(ImageFill_exports, {
  default: () => ImageFill_default
});
module.exports = __toCommonJS(ImageFill_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.10938 2.75H15.8906C16.4635 2.75 16.9518 2.95182 17.3555 3.35547C17.7721 3.75911 17.9805 4.25391 17.9805 4.83984V15.6016C17.9805 16.1875 17.7721 16.6823 17.3555 17.0859C16.9518 17.4896 16.4635 17.6914 15.8906 17.6914H5.10938C4.53646 17.6914 4.04818 17.4896 3.64453 17.0859C3.24089 16.6823 3.03906 16.1875 3.03906 15.6016V4.83984C3.03906 4.25391 3.24089 3.75911 3.64453 3.35547C4.04818 2.95182 4.53646 2.75 5.10938 2.75ZM16.3789 15.2891L12.8047 9.03906L10.0508 13.8438L8.33203 11.2656L5.65625 15.2891H16.3789ZM7.88281 9.03906C8.26042 9.03906 8.57943 8.90885 8.83984 8.64844C9.10026 8.38802 9.23047 8.07552 9.23047 7.71094C9.23047 7.33333 9.10026 7.01432 8.83984 6.75391C8.57943 6.49349 8.26042 6.36328 7.88281 6.36328C7.51823 6.36328 7.20573 6.49349 6.94531 6.75391C6.6849 7.01432 6.55469 7.33333 6.55469 7.71094C6.55469 8.07552 6.6849 8.38802 6.94531 8.64844C7.20573 8.90885 7.51823 9.03906 7.88281 9.03906Z",
      fill: "currentColor"
    }
  )
);
const SvgImageFill = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ImageFill_default = SvgImageFill;
